module.exports = __webpack_public_path__ + "img/google-podcast.7f5c93b.svg";